import { yupResolver } from "@hookform/resolvers/yup";
import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import * as yup from "yup";
import { fetchSlides } from "../../../../../redux/slides/SlidesAction";
import { postData, putData } from "../../../../utils/fetchData";

function useCreateSlide(item) {
  const dispatch = useDispatch();
  const [isDone, setIsDone] = React.useState(false);
  const [isSuccessfullySubmitted, setIsSuccessfullySubmitted] =
    React.useState(false);
  const [isFormRequestError, setIsFormRequestError] = React.useState(false);
  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        title: yup.string().required("Title is required."),
        order: yup.string().required("Order is required."),
        image: item
          ? yup
              .mixed()
              .test(
                "fileType",
                "Supported File Format (png,jpg,jpeg)",
                (value) => {
                  if (value)
                    return ["image/png", "image/jpeg", "image/jpg"].includes(
                      value.type
                    );
                  return true;
                }
              )
          : yup
              .mixed()
              .required("File is required.")
              .test(
                "fileType",
                "Supported File Format (png,jpg,jpeg)",
                (value) => {
                  return (
                    value &&
                    ["image/png", "image/jpeg", "image/jpg"].includes(
                      value.type
                    )
                  );
                }
              ),
      }),
    [item]
  );

  const {
    register,
    handleSubmit,
    errors,
    formState,
    clearErrors,
    watch,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      title: item?.title || "",
      order: item?.order?.toString() || "",
    },
  });

  const onSubmitForm = async (formValues, e) => {
    setIsSuccessfullySubmitted(true);
    let fd = new FormData();
    fd.append("title", formValues?.title);
    fd.append("order", formValues?.order);
    if (formValues?.image) {
      fd.append("image", formValues?.image);
    }
    console.log("data", formValues);
    let token = window.sessionStorage.getItem("userToken");
    var request;
    if (item) {
      request = putData(`slide/${item.id}/`, fd, token);
    } else {
      request = postData("slide/", fd, token);
    }
    await request
      .then(async () => {
        // console.log('resp', resp)
        // window.sessionStorage.setItem("userToken", resp?.token);
        await dispatch(fetchSlides());
        await Swal.fire({
          icon: "success",
          title: "Success!",
          showConfirmButton: false,
          timer: 1500,
        });
        await setIsSuccessfullySubmitted(false);
        if (item) {
          await window.$(`#AjouterSlideModal${item.id}`).modal("hide");
        } else {
          await window.$("#AjouterSlideModal").modal("hide");
          await e.target.reset();
        }

        await setIsDone(true);

        await reset();
        setTimeout(() => {
          setIsDone(false);
        }, 1000);
      })
      .catch((error) => {
        console.error("error", error, error?.response);
        if (error?.response?.data?.message) {
          Swal.fire({
            icon: "error",
            title: error?.response?.data?.message,
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (error?.response?.status === 500) {
          Swal.fire({
            icon: "error",
            title:
              "Oups! une erreur liée au serveur est survenue veuillez réessayer plus tard",
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (error?.response?.status === 400) {
          Swal.fire({
            icon: "error",
            title:
              "Oups! une erreur liée à la requête est survenue, veuillez contacter l'administrateur.",
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: `Oups! une erreur de statut ${error?.response?.status} est survenue, veuillez réessayer plus tard.`,
            showConfirmButton: false,
            timer: 2000,
          });
        }

        setIsSuccessfullySubmitted(false);
      });
  };
  return {
    register,
    errors,
    formState,
    isSuccessfullySubmitted,
    setIsSuccessfullySubmitted,
    setIsFormRequestError,
    isFormRequestError,
    clearErrors,
    watch,
    reset,
    setValue,
    onSubmit: handleSubmit(onSubmitForm),
    isDone,
  };
}

export default useCreateSlide;
